import {observer} from 'mobx-react';
import React from 'react';
import {X3LevelStore} from '../X3LevelStore';

@observer
export class EditUnitForm extends React.Component<{ store: X3LevelStore }> {
  render() {
    const {store} = this.props;

    if (store.editUnit === null)
      return null;

    const name = store.editUnit.name;
    return (
      <div className="row">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
